import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


export const toggleNotification = createAsyncThunk(
    'notifiaction/toogleNotification',
    async ({ token, section, key }, { rejectWithValue }) => {
        try {
            const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/${section}/notification/${key}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            if (response.data.status) {
                return response.data.response;
            }
            return rejectWithValue(response.data.message || "Unexpected response format");
        } catch (error) {

            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                "Error toggling notification status";
            return rejectWithValue(errorMessage);
        }
    }
);



const initialState = {
    loading: false
}

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(toggleNotification.pending, (state, action) => {
                state.loading = true
            })
            .addCase(toggleNotification.fulfilled, (state, action) => {
                state.loading = false
            }).addCase(toggleNotification.rejected, (state, action) => {
                state.loading = false
            });
    }

})

export default notificationSlice.reducer;